
import { useGetPreventas, useUpdatePreventa } from '@/shared/actions/erp';
import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from '@/shared/hooks';
import GeneralTable from '@/shared/components/ui/GeneralTable';
import { IDataPreventa } from '@/shared/interfaces';
import { Grid, Typography } from '@mui/material';
import { useTableColumnsPreventa } from '@/shared/hooks/useTableColumnsPreventa';
import { PermissionsEnum } from '@/auth/interfaces';
import { EstadoPreventaEnum, gridSizeMdLg12, TABLE_CONSTANTS } from '@/shared';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { useState } from 'react';
import CustomSearchFilterSupervisorVenta from '@/erp/sale/asesor/prospecto/componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta';

export default function TableSolicitudContratoFisico() {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_preventa,
    PermissionsEnum.api_change_preventa
  ]);

  ///* Hook
  const { columnsPreventaEspera } = useTableColumnsPreventa(EstadoPreventaEnum.EN_ESPERA);

  const {
    globalFilter,
    pagination,
    searchTerm,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,

    vendedor,
    setVendedor
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const [open, setOpen] = useState(false);
  const [dataSolicitud, setDataSolicitud] = useState<IDataPreventa | null>(null);

  const { pageIndex, pageSize } = pagination;

  const { isLoading, data: preventasRes,
    isRefetching, } = useGetPreventas(
      {
        estado_preventa_exclude: 'CANCELADO',
        identificacion: searchTerm,
        page: pageIndex + 1,
        page_size: pageSize,
        fecha_preventa_before: dateBefore,
        fecha_preventa_after: dateAfter,
        pre_requiere_contrato_fisico: true,
        estado_aceptacion: false,
        user_create: vendedor,
        ...filterObject,
        filterByState: false
      }
    );

  const { mutateAsync } = useUpdatePreventa({});


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomSearchFilterSupervisorVenta
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificación"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}

            setVendedor={setVendedor}
            //vendedor={vendedor}

          />
        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IDataPreventa>
            columns={columnsPreventaEspera}
            data={preventasRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={preventasRes?.data?.count}

            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // crud
            canDelete={false}
            positionActionsColumn='first'
            canEdit={true}
            onEdit={(row) => {

              setOpen(true);

              if (row)
                setDataSolicitud(row)

              /* setConfirmDialogIsOpen(true);
              setConfirmDialog({
                isOpen: true,
                title: 'Solicitud de contrato',
                subtitle:
                  'Se entregara los contratos y anexos en formato fisico al cliente, ¿Estas seguro de confirmar?',
                onClose() {
                  //window.location.reload();
                  setConfirmDialogIsOpen(false);

                },
                async onConfirm() {

                  await mutateAsync({
                    id: row.id_preventa,
                    data: {
                      pre_requiere_contrato_fisico: false,
                      requiere_contrato_fisico: true,
                      estado_aceptacion: true
                    }
                  })
                  setConfirmDialogIsOpen(false);
                },
                btnTitle: 'Cerrar',
              }); */

            }}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_SMALL}
          />
        </Grid>
      </Grid>

      {
        open && (
          <ScrollableDialogProps
            open={open}
            title={`Solicitud de contrato`}
            width="69%"
            onClose={() => setOpen(false)}
            onConfirm={async () => {

              if (dataSolicitud)
                await mutateAsync({
                  id: dataSolicitud.id_preventa,
                  data: {
                    pre_requiere_contrato_fisico: false,
                    requiere_contrato_fisico: true,
                    estado_aceptacion: true
                  }
                })

              setOpen(false);
              setDataSolicitud(null);

            }}
            confirmVariantBtn='contained'

            ///* rechazar
            onReject={async () => {

              if (dataSolicitud)
                await mutateAsync({
                  id: dataSolicitud.id_preventa,
                  data: {
                    pre_requiere_contrato_fisico: false,
                  }
                })

              setOpen(false)
              setDataSolicitud(null);

            }}
            showRejectBtn={true}
            contentNode={
              <>
                <Grid item xs={12} container spacing={1} alignItems="center">
                  <Grid item {...gridSizeMdLg12}>
                    <Typography>
                      {`Los contratos y anexos se entregarán al cliente en formato físico. Si rechazas, el contrato será en formato digital. ¿Estás seguro de que deseas confirmar?`}
                    </Typography>
                  </Grid>
                </Grid>
              </>
            }
          />
        )
      }

    </>
  );


}

